import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PROGRAM_MEDIA } from "@/data/site";

// Combo card: full-bleed property photo + Archer-in-role figure + text overlay.
export function ProgramCard({ slug, title, desc, Icon, accent = "gold", onFund, fundLabel, eyebrow }) {
  const media = PROGRAM_MEDIA[slug] || {};
  const iconColor = accent === "red" ? "text-brandred" : "text-gold";
  const inner = (
    <>
      {media.photo && (
        <img src={media.photo} alt="" aria-hidden
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[600ms] group-hover:scale-110" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/75 to-obsidian/25" />
      <div className="absolute inset-0 bg-gradient-to-r from-obsidian/95 via-obsidian/45 to-transparent" />
      {media.archer && (
        <img src={media.archer} alt="" aria-hidden
          className={`pointer-events-none absolute bottom-0 right-0 h-[92%] max-w-[50%] w-auto object-contain object-right-bottom z-10 drop-shadow-[0_18px_35px_rgba(0,0,0,0.75)] transition-transform duration-500 group-hover:-translate-y-1 ${media.flip ? "scale-x-[-1]" : ""}`} />
      )}
      <div className="relative z-20 h-full p-6 flex flex-col justify-end max-w-[64%]">
        {eyebrow && <span className="eyebrow mb-2 block">{eyebrow}</span>}
        <div className="w-11 h-11 rounded-xl bg-obsidian/80 border border-gold/40 grid place-items-center backdrop-blur mb-3">
          <Icon className={`w-5 h-5 ${iconColor}`} strokeWidth={1.7} />
        </div>
        <h3 className="h-display text-2xl text-white leading-tight">{title}</h3>
        <p className="mt-1.5 text-sm text-white/70 leading-relaxed">{desc}</p>
        {onFund ? (
          <div className="mt-4 flex items-center gap-3">
            <button onClick={(e) => { e.preventDefault(); onFund(); }} className="text-sm font-semibold text-white/70 hover:text-gold transition-colors whitespace-nowrap shrink-0">Learn More</button>
            <Button onClick={(e) => { e.preventDefault(); onFund(); }} size="sm"
              className={`rounded-full h-9 px-4 ml-auto ${accent === "red" ? "bg-brandred hover:bg-brandred/90 text-white font-bold" : "btn-gold"}`}
              data-testid={`program-card-${slug}-fund`}>{fundLabel}</Button>
          </div>
        ) : (
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-gold group-hover:gap-2 transition-all">
            Learn More <ArrowRight className="w-4 h-4" />
          </span>
        )}
      </div>
    </>
  );
  const base = "group relative block rounded-2xl overflow-hidden border min-h-[300px] bg-charcoal";
  const ring = accent === "red" ? "border-brandred/30 hover:border-brandred/60" : "border-edge hover:border-gold/50";
  if (onFund) return <div className={`${base} ${ring}`} data-testid={`program-card-${slug}`}>{inner}</div>;
  return <Link to={`/loan-programs/${slug}`} className={`${base} ${ring} transition-colors`} data-testid={`program-card-${slug}`}>{inner}</Link>;
}
